module.exports = __webpack_public_path__ + "static/img/column_img_11-1.ba53ae23.png";